import { HierarchyReadDto } from "./HierarchyReadDto";
import { HierarchyUpdateDto } from "./saveHierarchyData";

/**
 * Builds the hierarchy update DTO sent to the back end from the current hierarchy state.
 * Used by stand-alone hierarchy saves and by TLF item saves that include hierarchy changes.
 *
 * @param hierarchy - The hierarchy whose editable fields should be saved.
 * @returns The hierarchy update DTO containing only the editable fields.
 */
export const toHierarchyUpdateDto = (hierarchy: HierarchyReadDto): HierarchyUpdateDto => ({
  id: hierarchy.id,
  name: hierarchy.name,
  parentTag: hierarchy.parentTag,
  description: hierarchy.description,
  lists: hierarchy.lists,
  phase: hierarchy.phase,
  reportType: hierarchy.reportType,
  rowGroups: hierarchy.rowGroups,
  sections: hierarchy.sections,
  singles: hierarchy.singles,
  status: hierarchy.status,
  domainList: hierarchy.domainList,
  domainReplacements: hierarchy.domainReplacements,
  arsEnabled: hierarchy.arsEnabled,
  analysisMethods: hierarchy.analysisMethods,
  analysisSets: hierarchy.analysisSets,
  dataSubsets: hierarchy.dataSubsets,
  groupingFactors: hierarchy.groupingFactors,
  tlfTags: hierarchy.tlfTags,
});
